import { createSlice } from "@reduxjs/toolkit";

import { RootState } from "@/redux";

import { CopywritingFramework } from "../../pages/Company/schema/copywritingFramework";
import { copywritingFrameworkApi } from "./copywritingFramework.api";

interface CopywritingFrameworkState {
	frameworks: CopywritingFramework[];
}

const initialState: CopywritingFrameworkState = {
	frameworks: [],
};

export const copywritingFrameworkSlice = createSlice({
	name: "copywritingFramework",
	initialState,
	reducers: {},
	extraReducers: (builder) => {
		builder.addMatcher(
			copywritingFrameworkApi.endpoints.getCopywritingFrameworks.matchFulfilled,
			(state, { payload }) => {
				state.frameworks = payload;
			}
		);
	},
});

export const copywritingFrameworkReducer = copywritingFrameworkSlice.reducer;
export const copywritingFrameworkSelector = (state: RootState) =>
	state[copywritingFrameworkSlice.name];
